<script setup lang="ts">
import type { PropType } from "vue";

const props = defineProps({
  href: {
    type: String,
    default: "",
  },
  target: {
    type: String as PropType<"_blank" | "_parent" | "_self" | "_top" | null | undefined>,
    default: undefined,
    required: false,
  },
});

const { appUrl } = useRuntimeConfig().public;

function isHttpUrl(string: string) {
  let url;
  try {
    url = new URL(string);
  }
  catch {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}

const isExternal = computed(() => isHttpUrl(props.href) && !props.href.startsWith(appUrl));
</script>

<template>
  <NuxtLink
    :href="href"
    :target="isExternal ? '_blank' : target"
    :no-rel="isExternal ? undefined : true"
  >
    <slot />
  </NuxtLink>
</template>
